export enum SearchType {
    DEFAULT = 'default',
    ADVANCE = 'advance',
}

export enum TicketApiType {
    LIST = 'list',
    DEFAULTLIST = 'defaultList',
    FILTEREDLIST = 'filteredList',
}

export const DEFAULT_PAYLOAD = {
    ticketSubject: '',
    ticketComments: '',
    requestedByName: '',
    requestedBy: '',
    ticketQueues: '',
    ticketPriority: '',
    watchStatusAdvanced: '',
    watchStatusBasic: '',
    assignee: '',
    assigneeId: '',
    requestedBytagId: '',
    isReportPageCall: '',
    ticketNumber: '',
    submittedBefore: '',
    submittedAfter: '',
    ticketStatus: '',
    taskStatus: '',
    assignedToMe: false,
    unClaimedTicket: false,
    tagId: '',
    roleId: '',
    requester: '',
    userRole: '',
    archiveFlagValue: false,
    customFieldSelect: -1,
    customFieldSelectVal: '',
    ticketCategorySelect: -1,
    ticketType: '',
    filterticketStatus: '',
    userticketQueues: '',
    userFilter: '',
    pageNumber: '',
    sortBy: '',
    sortOrder: '',
    workGroupBytagId: '',
    csrftoken: '',
};

export const advanceFormKeys = [
    'ticketSubject',
    'ticketComments',
    'workGroupBytagId',
    'ticketQueues',
    'ticketStatus',
    'ticketNumber',
    'submittedAfter',
    'submittedBefore',
    'assignee',
    'tagId',
    'requestedByName',
    'requestedBytagId',
    'userRole',
    'requester',
    'customFieldSelect',
    'customFieldSelectVal',
    'ticketCategorySelect',
    'ticketType',
    'ticketPriority',
    'watchStatusAdvanced',
];

export const ANY = 'Any';

export const defaultOption = [{ value: ANY, text: ANY }];

export const ticketStatusOptions = [
    ...defaultOption,
    { value: 'Awaiting_Internal', text: 'ticketList.dropdown.ticketStatus.awatingInternal' },
    { value: 'Awaiting_Requestor', text: 'ticketList.dropdown.ticketStatus.awaitingRequestor' },
    { value: 'Canceled', text: 'ticketList.dropdown.ticketStatus.canceled' },
    { value: 'Open', text: 'ticketList.dropdown.ticketStatus.open' },
    { value: 'UnClaimed', text: 'ticketList.dropdown.ticketStatus.unclaimed' },
    { value: 'Resolved', text: 'ticketList.dropdown.ticketStatus.resolved' },
];

export const ticketStatusAdvanceOptions = [
    { key: 'Awaiting_Internal', value: 'ticketList.dropdown.ticketStatus.awatingInternal' },
    { key: 'Awaiting_Requestor', value: 'ticketList.dropdown.ticketStatus.awaitingRequestor' },
    { key: 'Canceled', value: 'ticketList.dropdown.ticketStatus.canceled' },
    { key: 'Open', value: 'ticketList.dropdown.ticketStatus.open' },
    { key: 'Resolved', value: 'ticketList.dropdown.ticketStatus.resolved' },
    { key: 'UnClaimed', value: 'ticketList.dropdown.ticketStatus.unclaimed' },
];

export const ticketPriorityOptions = [
    { key: 'Critical', value: 'ticketList.dropdown.ticketPriority.critical' },
    { key: 'High', value: 'ticketList.dropdown.ticketPriority.high' },
    { key: 'Medium', value: 'ticketList.dropdown.ticketPriority.medium' },
    { key: 'Low', value: 'ticketList.dropdown.ticketPriority.low' },
];

export const watchStatusAdvancedOptions = [
    { key: 'watching', value: 'ticketList.dropdown.watchStatus.watching' },
    { key: 'notWatching', value: 'ticketList.dropdown.watchStatus.notWatching' },
];

export const ticketAssignmentOptions = [
    { value: 'myWorkgroupFilter', text: 'ticketList.dropdown.ticketAssignment.anyInMyWorkgroup' },
    { value: 'createdByMeFilter', text: 'ticketList.dropdown.ticketAssignment.createdByMe' },
    { value: 'assignedToMeFilter', text: 'ticketList.dropdown.ticketAssignment.assignedToMe' },
];

export const watcherStatusOptions = [
    { value: 'all', text: 'All' },
    { value: 'watching', text: 'ticketList.dropdown.watchStatus.watching' },
    { value: 'notWatching', text: 'ticketList.dropdown.watchStatus.notWatching' },
];

export enum DefaultDropdownType {
    WORKGROUP = 'workgroup',
    TICKET_STATUS = 'ticketStatus',
    TICKET_ASSIGNMENT = 'ticketAssignment',
}

export const defaultSearchValue = {
    workgroup: ANY,
    ticketStatus: 'Open',
    ticketAssignment: 'assignedToMeFilter',
    watchStatusBasic: 'all',
};

export const advanceSearchValue = {
    ticketQueues: [],
    ticketStatus: [],
    ticketAssignment: 'assignedToMeFilter',
    ticketSubject: '',
    ticketComments: '',
    ticketPriority: [],
    watchStatusAdvanced: [],
    ticketNumber: '',
    submittedAfter: '',
    submittedBefore: '',
    assignee: '',
    assigneeId: '',
    tagId: '',
    requestedBy: '',
    requestedByName: '',
    requestedBytagId: '',
    userRole: '',
    requester: '',
    roleId: '',
    customFieldSelect: '',
    customFieldSelectVal: '',
    ticketCategorySelect: '',
    ticketType: [],
    workGroupBytagId: '',
    customFieldSelectValOptionId: '',
};

export const markAsDocumentOptions = [
    { value: '', text: 'Select' },
    { value: 'accepted', text: 'Accepted' },
    { value: 'rejected', text: 'Rejected' },
];

export const rejectReasonOptions = [
    { value: '', text: 'form.option.select' },
    {
        value: 'ticketList.dropdown.rejectReason.noApplicationMatch',
        text: 'ticketList.dropdown.rejectReason.noApplicationMatch',
    },
    {
        value: 'ticketList.dropdown.rejectReason.recentDocRequired',
        text: 'ticketList.dropdown.rejectReason.recentDocRequired',
    },
    {
        value: 'ticketList.dropdown.rejectReason.notApplicable',
        text: 'ticketList.dropdown.rejectReason.notApplicable',
    },
    {
        value: 'ticketList.dropdown.rejectReason.unreadable',
        text: 'ticketList.dropdown.rejectReason.unreadable',
    },
];

export const CANCEL_REASON_MAX_LENGTH = 100;
export const CANCEL_REASON_COLS = 40;
export const CANCEL_REASON_ROWS = 4;

export const COMPLETE_INTERNAL_COMMENT_MAX_LENGTH = 1999;
export const COMPLETE_INTERNAL_COMMENT_COLS = 200;
export const COMPLETE_INTERNAL_COMMENT_ROWS = 7;

export const VERIFY_COMPLETE_INTERNAL_COMMENT_MAX_LENGTH = 1999;
export const VERIFY_COMPLETE_INTERNAL_COMMENT_COLS = 200;
export const VERIFY_COMPLETE_INTERNAL_COMMENT_ROWS = 7;

export const VERIFY_COMPLETE_EXTERNAL_COMMENT_MAX_LENGTH = 1999;
export const VERIFY_COMPLETE_EXTERNAL_COMMENT_COLS = 200;
export const VERIFY_COMPLETE_EXTERNAL_COMMENT_ROWS = 7;

export enum customFieldTypes {
    TEXT_BOX = 'TEXT_BOX',
    OPTION_LIST = 'OPTION_LIST',
    DATE_INPUT = 'DATE_INPUT',
}

export const CustomFiedType = [customFieldTypes.TEXT_BOX, customFieldTypes.OPTION_LIST, customFieldTypes.DATE_INPUT];

export const pendingReport = 'ticket/pendingreport';

export const defaultOptions = [{ value: '', text: 'Select' }];

export enum popoverActions {
    CLAIM = 'claim',
    COMPLETE = 'complete',
    REASSIGN = 'Reassign',
    ASSIGN = 'Assign',
}

export enum permissions {
    TKM_WORKFLOW_VERIFY = 'TKM_WORKFLOW_VERIFY',
}

export const reopenNotAllowedWorkgroup = [
    'Document Verification Workgroup',
    'DMI Workgroup',
    'Qle Validation Workgroup',
];

export enum CompleteTicketAction {
    INTERNAL = 'internal',
    REQUESTOR = 'requestor',
    CLAIM = 'claim',
    COMPLETE = 'complete',
}

export enum validateTypes {
    Y = 'Y',
    N = 'N',
}

export enum ticketCategoryOptions {
    DOCUMENT_VERIFICATION = 'Document Verification',
    QLE = 'QLE',
}

export enum taskStatusTypes {
    CLAIMED = 'Claimed',
    UNCLAIMED = 'UnClaimed',
    REOPENED = 'Reopened',
    RESTARTED = 'Restarted',
    CANCELED = 'Canceled',
    OPEN = 'Open',
    RESOLVED = 'Resolved',
}

export enum ticketStatusTypes {
    OPEN = 'Open',
    RESOLVED = 'Resolved',
    CANCELED = 'Canceled',
    COMPLETED = 'Completed',
    UNCLAIMED = 'Unclaimed',
}

export enum booleanTypes {
    TRUE = 'true',
    FALSE = 'false',
}

export const AUTOCOMPLETE_DEBOUNCE_DELAY = 300;
export const AUTOCOMPLETE_MIN_SEARCH_QUERY_LENGTH = 2;

export const TICKET_LIST_SEARCH_VARS = 'ticketListSearchVarsV1';
export const TICKET_LIST_PAGE_INFO = 'ticketListPageInfo';
export const TICKET_LIST_SEARCH_FROM_REPORTS = 'ticketListSortFromChart';


